
const NitUtils = {

    isValidValue: (e) => {
        let value = e.target.value;
    
        if (/\s/.test(value)) {
            return false;
        }
    
        value = value ? value.replace(/\s+/g, '') : '';
    
        if (value.length > 12) {
            return false;
        }
    
        return true;
    },

    applyMask: (nit) => {
        // Remove non-numeric characters
        nit = nit.replace(/[^0-9]/gi, '');

        let masked = '';

        // Iterate through characters and apply mask
        for (let i = 0; i < nit.length; i++) {
            masked += nit[i];
            // Add dots after 3rd and 6th digits
            if (i === 2 || i === 5) {
                masked += '.';
            }
            // Add the hyphen before the check digit
            if (i === nit.length - 2) {
                masked += '-';
            }
        }

        return masked;
    },

    removeMask: (nit) => {

        return nit.replace(/[^0-9]/gi, '');
    },
    nit: (value) => {
     // Remove non-numeric characters
     value = value.replace(/\.|\/|-/gi, '');
    

     // Convert string of digits to array of numbers
     let digits = value.split('').map(Number);
 
     // The NIT must have at least 2 digits (a base number and the check digit)
     if (digits.length < 2)
         return 'O NIT deve conter pelo menos 2 números';
 
    
    return '';
    }

}

export default NitUtils